import { isNil } from 'ramda';

import { camelize } from '../utils/keysConverter';

export const convertErrorsToArray = (errors) => {
  if (isNil(errors)) return [];

  const camelizeErrors = camelize(errors);

  return Object.keys(camelizeErrors).reduce((errorsArray, key) => {
    errorsArray.push({
      key: key,
      messages: [camelizeErrors[key]],
    });
    return errorsArray;
  }, []);
};

export const apiErrorsToFormik = (error) => {
  const { errors } = error.response.data || {};
  const camelizedErrors = camelize(errors);
  return Object.keys(camelizedErrors).reduce(
    (acc, key) => ({ ...acc, [key]: camelizedErrors[key].join(', ') }),
    {}
  );
};

export const graphErrorsToFormik = (errors) => {
  const normalizedErrors = errors.reduce((acc, error) => {
    const { key, messages } = error;
    return { ...acc, [key]: messages.join(', ') };
  }, {});

  return normalizedErrors;
};
